import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaTags,
  FaRegCheckCircle,
  FaArrowRight,
  FaFileAlt,
  FaUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";

const SBI = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }
  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  // const currentCards = CreditCardData.cards?.filter((card)=>card.category==="Credit card").slice(indexOfFirstCard, indexOfLastCard);
  // console.log({currentCards})
  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("sbi"))
    .slice(indexOfFirstCard, indexOfLastCard);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const faqs = [
    {
      question: "How many types of credit cards does SBI offer?",
      answer:
        "   SBI offers a wide range of credit cards including shopping, fuel, travel, business, cashback, and lifestyle cards like SBI SimplyCLICK, SBI Prime, Elite, IRCTC Card, and more.",
    },
    {
      question: "Are there any lifetime free credit cards from SBI?",
      answer:
        " Yes, some SBI cards offer lifetime free membership or waive annual fees upon meeting minimum annual spending milestones. Always check the card-specific terms before applying.",
    },
    {
      question: "How long does the approval and dispatch process take?",
      answer:
        " Post-verification, the approval process generally takes 2–3 business days. Once approved, the physical card is dispatched within 7–10 working days.",
    },
    {
      question: "What is the interest rate on SBI credit cards?",
      answer:
        "  The interest rates on SBI cards generally range from 2.5% to 3.5% per month depending on the card type and your credit profile.",
    },
    {
      question: " Does SBI Card offer a reward points platform?",
      answer:
        "   Yes, SBI Card has a dedicated rewards platform where users can redeem points for merchandise, vouchers, air miles, and more. The value of reward points varies across different cards.",
    },
  ];

  const steps = [
    {
      icon: <FaTags className="h-6 w-6 text-orange-500" />,
      title: "Evaluate Eligibility",
      description:
        "  Ensure you meet the age, income, and credit score requirements for the specific SBI card you wish to apply for.",
    },
    {
      icon: <FaRegCheckCircle className="h-6 w-6 text-green-500" />,
      title: "Keep Your Documents Ready",
      description:
        "  Prepare the required KYC and income documents in advance to ensure a smooth and fast application process.",
    },
    {
      icon: <FaArrowRight className="h-6 w-6 text-purple-600" />,
      title: "Redirect to SBI Card’s Official Portal",
      description:
        "Once you've chosen a suitable card, click “Apply Now” to be securely redirected to SBI Card’s official website, where you can complete the application process.",
    },
    {
      icon: <FaFileAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "Browse through our curated selection of SBI credit cards on TheFinMaster. Each listing is detailed with unique benefits, reward structures, annual fees, and suitability—helping you make informed decisions based on your lifestyle and financial goals.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
        SBI Credit Cards – Best Cards, Features & Application
        </title>
        <meta
          name="description"
          content="Explore top SBI credit cards for travel, shopping & rewards. Compare features and apply online easily."
        />
        <meta
          name="keywords"
          content="sbi simply click credit card, best sbi credit card, sbi prime credit card, cash back sbi credit card, rupay credit card sbi, sbi bill desk, sbi bpcl credit card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/sbi-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>

        <div className="flex justify-center items-center  p-4 ">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Discover the Most Trusted and Rewarding Credit Cards from SBI
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              SBI Card, one of India’s largest credit card issuers, offers a
              diverse range of credit cards that cater to shopping, travel,
              lifestyle, business, and everyday use. Whether you're looking for
              cashback, air miles, or exclusive lounge access, SBI credit cards
              are tailored to fit every user’s needs and spending habits.
            </p>
          </div>
        </div>
        <h1 className="text-center font-bold text-2xl md:text-3xl my-10 text-gray-800">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

          <div className="w-full relative ">
            <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
              {/* <div className="w-[70%] mx-auto">
                                         <h2 className="text-center font-medium pt-5 text-lg">
                                           <span className="font-semibold text-white">816 people</span>{" "}
                                           are on call with our advisors right now
                                         </h2>
                                       </div> */}
              <div className="w-full mx-auto">
                <Link
                  to="https://play.google.com/store/apps/details?id=com.myairtelapp&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="w-[80%] mx-auto ">
                    <img src="/assets/sidebanner.png" alt="Advertisement" />
                  </div>
                </Link>
                <div className="bg-white">
                  {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                             Know your advisor
                                           </h3> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

        {/* <div className='w-[95%] py-10'>
                <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                <AccordionComponent />
            </div> */}

        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for SBI Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score
                  </span>
                  <span>
                    {" "}
                    A good CIBIL score of 700 and above is preferred. A healthy
                    credit score reflects your creditworthiness and boosts your
                    chances of approval significantly.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Residential Status
                  </span>
                  <span>
                    {" "}
                    Applicants must be Indian residents with a verifiable
                    residential address. Some premium cards may also be
                    available to NRIs subject to eligibility.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Clean Credit History
                  </span>
                  <span>
                    {" "}
                    Applicants must not have any past defaults on loans or
                    credit cards. A clean credit repayment track record is
                    essential to pass SBI Card’s internal risk assessment.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Steady Income Source
                  </span>
                  <span>
                    {" "}
                    Both salaried and self-employed applicants must have a
                    steady income. Basic SBI cards typically require a monthly
                    income of ₹20,000–₹25,000, whereas premium cards may require
                    ₹50,000 or more.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Age Requirement
                  </span>
                  <span>
                    {" "}
                    The applicant must be at least 21 years of age for a primary
                    card and 18 years for an add-on card. This ensures legal and
                    financial maturity before handling a credit line.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for SBI Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Identity
                  </span>
                  <span>
                    {" "}
                    Acceptable documents include Aadhaar Card, Voter ID, PAN
                    Card, or Passport. This helps establish your legal identity
                    for the KYC process.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Address
                  </span>
                  <span>
                    {" "}
                    Recent utility bills, Aadhaar, Passport, or rental agreement
                    (within 3 months) serve as valid address proof. These
                    documents verify your place of residence.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Income
                  </span>
                  <span>
                    {" "}
                    Salaried: Last 3 months’ salary slips or Form 16.
                    Self-employed: Latest ITR with audited financial statements
                    These documents help the bank assess your income stability.{" "}
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Recent Photograph
                  </span>
                  <span>
                    {" "}
                    A passport-sized color photograph is required along with the
                    application form for identity and record-keeping purposes.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Pan Card
                  </span>
                  <span>
                    {" "}
                    Mandatory as it links all your financial activities and is
                    essential for credit scoring and tax reporting.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for SBI Bank Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
      Applying for a fuel credit card is a seamless process that starts with the right research and ends at the official bank’s platform for final submission. Here’s how you can get started through TheFinMaster.com:
      </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SBI;
